import * as React from 'react';
import { MenuItem } from '@mui/material';
import { FormControl, FormHelperText, Select } from '@mui/material';

import { useEffect, useState } from 'react';

const SampleMenuList = (props) => {
	const [checked, setChecked] = useState(0);
	const [anchorEl, setAnchorEl] = React.useState(null);
	const [value, setValue] = useState('Number of samples');
	const open = Boolean(anchorEl);

	const handleToggle = (value) => {
		setAnchorEl(null);
		if (value !== checked) {
			setChecked(value);
			props.onFilterChange(props.filters[value]);
		}
	};
	const [isMobile, setIsMobile] = useState(window.innerWidth <= 900);
	useEffect(() => {
		function handleResize() {
			setIsMobile(window.innerWidth <= 900);
		}
		window.addEventListener('resize', handleResize);
		return (_) => {
			window.removeEventListener('resize', handleResize);
		};
	});

	const handleSelectChange = (event) => {
		setValue(event.target.value);
	};

	return (
		<Select
			value={value}
			onChange={handleSelectChange}
			sx={[
				{
					'&.Mui-focused .MuiOutlinedInput-notchedOutline': {
						borderColor: '#22294D'
					},

					width: '100%'
				}
			]}
		>
			{props.filters.map((c, idx) => {
				const labelId = `checkbox-list-label-${idx}`;
				return (
					<MenuItem
						onClick={handleToggle.bind(this, idx)}
						key={idx}
						id={labelId}
						value={c}
					>
						{c}
					</MenuItem>
				);
			})}
		</Select>
	);
};

export default SampleMenuList;
